var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#068B2A",
  d: "M12 22.245c5.595 0 10.245-4.64 10.245-10.245 0-5.595-4.66-10.246-10.255-10.246C6.385 1.754 1.754 6.405 1.754 12c0 5.605 4.641 10.245 10.246 10.245m0-1.707A8.497 8.497 0 0 1 3.472 12c0-4.731 3.777-8.538 8.518-8.538A8.533 8.533 0 0 1 20.538 12 8.505 8.505 0 0 1 12 20.538m-1.266-3.516c.332 0 .603-.16.814-.472l4.962-7.804c.12-.201.241-.432.241-.653 0-.462-.402-.744-.824-.744-.27 0-.522.15-.703.452l-4.54 7.263-2.33-3.014c-.221-.301-.462-.412-.734-.412a.8.8 0 0 0-.793.814c0 .22.09.432.231.623L9.87 16.55c.272.332.533.472.864.472"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark-icon.71bd998ba61242a9d1ba6f1cf3bbc693.svg";